import { AxiosError, AxiosResponse } from "axios";
import { ListResponseDataT } from "@interfaces/internal-study/list";

export type GetListPagePropsT = (params: {
  companyId: number | null;
  id: string;
}) => void;

export type InternalListTraineesMember = {
  id: number;
  email: string;
  inn: string;
  name: string;
  phone: string;
  snils: string;
  employmentDate: number;
  sex: string;
  position: string;
  department: string;
  programs: {
    id: number;
    title: string;
    checked?: boolean;
  }[];
  protocol_number?: string;
};

export type InternalListProcessMember = {
  members: {
    id: number;
    name: string;
    protocol_number: string;
  }[];
  file: string;
};

export type InternalListFinishMember = {
  groups: {
    title: string;
    protocol_number: string;
    members: {
      name: string;
      position: string;
      company: string;
      id_record: string;
      result: boolean;
    }[];
    file: {
      title: string;
      path: string;
    };
  }[];
  file: {
    title: string;
    path: string;
  };
};

export type InternalListComissionInfo = {
  id: number;
  title: string;
  members: string[];
};

export type InternalTrainingTraineesToProcess = {
  id: string;
  from: InternalListTraineesMember[];
  to: InternalTrainingSteps.Process;
};

export type InternalTrainingTraineesToFinish = {
  id: string;
  file: File;
};

export type CreateNewListPropsT = (params: {
  companyId: number;
  title: string;
  comission: number;
  trainees_members: InternalListTraineesMember[];
  cb: (err: AxiosError | null, res?: AxiosResponse<ListResponseDataT>) => void;
}) => void;

export type UpdateListPropsT = (params: {
  id: number;
  title: string;
  comission: number;
  cb: (err: AxiosError | null) => void;
}) => void;

export enum InternalTrainingSteps {
  Trainees = "trainess",
  Process = "process",
  Finish = "finish",
}

export type InternalListSelectedPrograms = {
  employee: number;
  programs: {
    id: number;
  }[];
};

export type DownloadProtocolFileParams = {
  id: string;
  filename: string;
};
